class AssetLoaderClass {
    constructor() {
        this.loaded = false;
        this.rendering = false;
        this.scripts = [];
        this.styles = [];
        this.stylesLoaded = {};
        this.scriptsLoaded = {};
        this.renderTimeout = 0;
    }

    /**
     * Limpa tudo
     */
    clear() {
        document.querySelectorAll('[data-asset-loaded]').remove();
        this.stylesLoaded = {};
        this.scriptsLoaded = {};
    }

    /**
     * Adiciona código de javascript para quando a execução estiver disponível
     * @param code
     */
    ready(code) {
        this.addScript(code, true, false);
    }

    addScripts(scripts) {
        let loaded = this.loaded;
        this.loaded = false;
        for (let script of scripts) {
            this.addScript(script.code, script.isCode, script.unique, script.module ?? false);
        }

        this.loaded = loaded;
        if (this.loaded && !this.rendering)
            this.render();
    }

    /**
     * Adiciona um arquivo de js ou código
     * @param code
     * @param isCode se for código especificar true
     * @param unique se o arquivo só deve ser incluído uma vez, especificar true
     * @param module se usa module
     */
    addScript(code, isCode, unique, module = false) {
        this.scripts.push({
            code: isCode ? code : (code.indexOf('https://') === 0 ? '' : '/') + (code.replace(/^\/+/gm, "")),
            isCode: isCode === true,
            unique: unique === true,
            module
        });

        if (this.loaded && !this.rendering)
            this.render();
    }

    addStyles(styles) {
        let loaded = this.loaded;
        this.loaded = false;

        for (let style of styles) {
            this.addStyle(style.code ? style.code : style, style.isCode ? style.isCode : false);
        }

        this.loaded = loaded;
        if (this.loaded && !this.rendering)
            this.render();
    }

    /**
     * Adiciona um arquivo css ou style
     * @param code
     * @param isCode se for style especificar true
     */
    addStyle(code, isCode) {
        this.styles.push({
            code: code,
            isCode: isCode === true
        });

        if (this.loaded && !this.rendering)
            this.render();
    }

    needRender() {
        return this.scripts.length > 0 || this.styles.length > 0;
    }

    async finishSynchronousRender() {
        return new Promise((resolve) => {
            if (this.needRender()) {
                this.render().then(() => {
                    resolve(true);
                })
            } else {
                resolve(true);
            }
        });
    }

    async synchronousRender(batches) {
        if (batches.length === 0) {
            return this.finishSynchronousRender();
        }

        return new Promise(async (resolve) => {
            let script;

            let curBatch = batches.shift();

            let totalScripts = curBatch.length;
            let loadedScripts = 0;


            for (script of curBatch) {
                if (script.isCode) {
                    let usedLaterScript = document.createElement('script');
                    usedLaterScript.type = 'text/javascript';
                    usedLaterScript.setAttribute('data-asset-loaded', 1);
                    usedLaterScript.setAttribute('data-href', window.location.href);
                    if (script.module) {
                        usedLaterScript.type = 'module';
                    }

                    let code = script.code
                        .toString().trim();

                    if (code.match(/^function(\s+)?[(](\s+)?[)](\s+)?[{]/i)) {
                        code = code.replace(/^function(\s+)?[(](\s+)?[)](\s+)?[{]/i, '')
                            .replace(/[}](\s+)?$/i, '');
                    } else if (code.match(/^(\s+)?[(](\s+)?[)](\s+)?=>(\s+)?[{]/i)) {
                        code = code.replace(/^(\s+)?[(](\s+)?[)](\s+)?=>(\s+)?[{]/i, '')
                            .replace(/[}](\s+)?$/i, '');
                    }

                    usedLaterScript.appendChild(document.createTextNode(code /*.slice(13, -1)*/));
                    document.body.appendChild(usedLaterScript);
                    loadedScripts++;

                    if (loadedScripts === totalScripts) {
                        await this.synchronousRender(batches);
                        resolve(true);
                    }
                } else {
                    let usedLaterScript = document.createElement('script');
                    usedLaterScript.type = 'text/javascript';
                    usedLaterScript.setAttribute('data-cfasync', 'false');
                    usedLaterScript.setAttribute('data-asset-loaded', 1);
                    usedLaterScript.setAttribute('data-href', window.location.href);
                    usedLaterScript.src = script.code;
                    if (script.module) {
                        usedLaterScript.type = 'module';
                    }
                    usedLaterScript.onload = async () => {
                        loadedScripts++;
                        if (loadedScripts === totalScripts) {
                            await this.synchronousRender(batches);
                            resolve(true);
                        }
                    }
                    document.body.appendChild(usedLaterScript);
                    this.scriptsLoaded[script.code] = true;
                }
            }
        });
    }

    /**
     * Renderiza os arquivos adicionados na tela
     */
    render() {
        this.rendering = true;

        return new Promise(resolve => {
            clearTimeout(this.renderTimeout);

            // timeout para dar chance de chamar outro addScript na execução
            this.renderTimeout = setTimeout(() => {
                let scripts = this.scripts;
                let styles = this.styles;

                this.styles = [];
                this.scripts = [];

                let script, style;

                while (styles.length) {
                    style = styles.shift();
                    let usedStyle
                    if (style.isCode) {
                        usedStyle = document.createElement('style');
                        usedStyle.appendChild(document.createTextNode(style.code));
                        usedStyle.setAttribute('data-asset-loaded', 1);
                        document.body.appendChild(usedStyle);
                    } else if (!(this.stylesLoaded[style.code])) {
                        usedStyle = document.createElement('link');
                        usedStyle.rel = 'stylesheet';
                        usedStyle.type = 'text/css';
                        usedStyle.href = style.code;
                        usedStyle.media = 'all';
                        usedStyle.setAttribute('data-asset-loaded', 1);
                        usedStyle.src = style.code;
                        document.body.appendChild(usedStyle);
                        this.stylesLoaded[style.code] = true;
                    }
                    // se for src, verifica se já não incluiu

                }

                let batches = [];
                let curBatch = [];
                let lastCode = false;
                while (scripts.length) {
                    script = scripts.shift();
                    if (!script.isCode && script.unique  && this.scriptsLoaded[script.code]) {
                        continue;
                    }

                    if (curBatch.length === 0) {
                        curBatch.push(script);
                    } else {
                        if (script.isCode && !lastCode) {
                            batches.push(curBatch);
                            curBatch = [script];
                        } else {
                            curBatch.push(script);
                        }
                    }
                    if (script.isCode) {
                        lastCode = true;
                    } else {
                        lastCode = false;
                        this.scriptsLoaded[script.code] = true;
                    }
                }
                if (curBatch.length)
                    batches.push(curBatch);

                this.synchronousRender(batches).then(() => {
                    this.rendering = false;
                    resolve(true);
                })
            }, 100);
        });
    }
}

window.AssetLoader = new AssetLoaderClass();
